export const hosts = {
  userApi: process.env?.REACT_APP_USER_API_URL || '',
  reachoutApi: process.env?.REACT_APP_REACHOUT_API_URL || '',
  campaignsApi: process.env?.REACT_APP_CAMPAIGNS_API_URL || '',
  notificationsApi: process.env?.REACT_APP_NOTIFICATIONS_API_URL || '',
  searchApi: process.env?.REACT_APP_SEARCH_API_URL || '',
  crawlerSocketApi: process.env?.REACT_APP_CRAWLER_API_URL || '',
  chatApi: `${process.env?.REACT_APP_BASE_API_URL}/chat-job/v1`,
  atsGatewayApi: process.env?.REACT_APP_ATS_GATEWAY_API_URL || '',
  vectorSearchApi: `${process.env?.REACT_APP_BASE_API_URL}/vector_search/v1`,
  communicationApi: `${process.env?.REACT_APP_BASE_API_URL}/communication/v1`,
  intakeApi: process.env?.REACT_APP_BASE_API_URL || '',
};
